const dict = {
  uk: {
    editProfile: 'Редагувати профіль',
    settings: 'Налаштування',
    email: 'Email',
    phone: 'Телефон',
    birthDate: 'Дата народження',
    videoIntro: 'Відео-візитка',
    videoIntroEmpty: 'Відео-візитка не завантажена',
    certificates: 'Сертифікати',
    certificatesEmpty: 'Сертифікати не завантажені',
    registeredOn: 'Дата реєстрації',
    subscribers: 'підписників',
    subscriptions: 'підписок',
    students: 'учнів',
    averageRating: 'Середній рейтинг',
    absenceRequest: 'Заявка на відсутність',
    changeAvatar: 'Змінити аватар',
    pickAvatar: 'Обрати аватар',
    changePhoto: 'Змінити фото',
    inviteFriend: 'Запросити друга',
    followers: 'Підписники',
    following: 'Підписки',
    noFollowersYet: 'Ще немає підписників',
    noFollowingYet: 'Ще немає підписок',
    nothingFound: 'Нічого не знайдено',
    searchPlaceholder: 'Пошук за нікнеймом або ім\'ям',
    clear: 'Очистити',
    follow: 'Підписатися',
    unfollow: 'Відписатися',
    englishLevel: 'Рівень англійської',
    completeTestPersonalized: 'Завершіть тест для персоналізованого навчання',
    takeTestForLevel: 'Пройдіть тест для визначення рівня',
    completeTest: 'Завершіть тест',
    takeTest: 'Пройти тест',
    completeTestProgress: 'Завершити тест ({{done}}/{{total}})',
    emailEmptyError: 'Email не може бути порожнім. Введіть коректний email або скасуйте зміни.',
    statisticsTitle: 'Статистика',
    lessonsConducted: 'Проведено уроків',
    activeStudents: 'Активних учнів',
    voiceMessage: 'Голосове повідомлення',
    videoUploadHint: 'Завантажте відео, щоб студенти могли ознайомитися з вами',
    videoUploading: 'Завантаження...',
    videoAdd: 'Додати відео',
    videoReplace: 'Замінити відео',
    videoDelete: 'Видалити відео',
    videoUploadError: 'Помилка завантаження',
    certificatesAdd: 'Додати сертифікат',
    certificatesUploading: 'Завантаження...',
    certificateHint: 'Тільки зображення (JPG, PNG, GIF, WebP)',
    certificateDelete: 'Видалити',
    certificateDeleteConfirm: 'Видалити цей сертифікат?',
    certificateFallback: 'Сертифікат',
    certificateOpenInNewTab: 'Відкрити в новій вкладці',
    certificateFormatHint: 'PDF, JPEG, PNG, WebP до 10 МБ',
    certificateDeleteTooltip: 'Видалити сертифікат',
    completedLessons: 'Завершено уроків',
    completedExercises: 'Виконано завдань',
    activeCourses: 'Активні курси',
    notificationSettings: 'Налаштування сповіщень',
    userProfile: 'Профіль користувача',
    profileHidden: 'Профіль прихований',
    profileHiddenDesc: 'Цей користувач приховав свій профіль від інших користувачів.',
    userNotFound: 'Користувача не знайдено',
    loadProfileError: 'Помилка завантаження профілю',
    writeMessage: 'Написати повідомлення',
    roleTeacher: 'Вчитель',
    roleStudent: 'Учень',
    roleAdmin: 'Адміністратор',
    back: 'Назад',
    close: 'Закрити',
  },
  en: {
    editProfile: 'Edit profile',
    settings: 'Settings',
    email: 'Email',
    phone: 'Phone',
    birthDate: 'Date of birth',
    videoIntro: 'Video intro',
    videoIntroEmpty: 'Video intro not uploaded',
    certificates: 'Certificates',
    certificatesEmpty: 'Certificates not uploaded',
    registeredOn: 'Registered on',
    subscribers: 'followers',
    subscriptions: 'following',
    students: 'students',
    averageRating: 'Average rating',
    absenceRequest: 'Absence request',
    changeAvatar: 'Change avatar',
    pickAvatar: 'Pick avatar',
    changePhoto: 'Change photo',
    inviteFriend: 'Invite a friend',
    followers: 'Followers',
    following: 'Following',
    noFollowersYet: 'No followers yet',
    noFollowingYet: 'Not following anyone yet',
    nothingFound: 'Nothing found',
    searchPlaceholder: 'Search by nickname or name',
    clear: 'Clear',
    follow: 'Follow',
    unfollow: 'Unfollow',
    englishLevel: 'English level',
    completeTestPersonalized: 'Complete the test for personalised learning',
    takeTestForLevel: 'Take the test to determine your level',
    completeTest: 'Complete test',
    takeTest: 'Take test',
    completeTestProgress: 'Complete test ({{done}}/{{total}})',
    emailEmptyError: 'Email cannot be empty. Enter a valid email or cancel your changes.',
    statisticsTitle: 'Statistics',
    lessonsConducted: 'Lessons conducted',
    activeStudents: 'Active students',
    voiceMessage: 'Voice message',
    videoUploadHint: 'Upload a video so students can get to know you',
    videoUploading: 'Uploading...',
    videoAdd: 'Add video',
    videoReplace: 'Replace video',
    videoDelete: 'Delete video',
    videoUploadError: 'Upload failed',
    certificatesAdd: 'Add certificate',
    certificatesUploading: 'Uploading...',
    certificateHint: 'Images only (JPG, PNG, GIF, WebP)',
    certificateDelete: 'Delete',
    certificateDeleteConfirm: 'Delete this certificate?',
    certificateFallback: 'Certificate',
    certificateOpenInNewTab: 'Open in new tab',
    certificateFormatHint: 'PDF, JPEG, PNG, WebP up to 10 MB',
    certificateDeleteTooltip: 'Delete certificate',
    completedLessons: 'Lessons completed',
    completedExercises: 'Exercises completed',
    activeCourses: 'Active courses',
    notificationSettings: 'Notification settings',
    userProfile: 'User profile',
    profileHidden: 'Profile hidden',
    profileHiddenDesc: 'This user has hidden their profile from other users.',
    userNotFound: 'User not found',
    loadProfileError: 'Failed to load profile',
    writeMessage: 'Send message',
    roleTeacher: 'Teacher',
    roleStudent: 'Student',
    roleAdmin: 'Administrator',
    back: 'Back',
    close: 'Close',
  },
};

export default dict;
